// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3nmMT","content":"ManualTimeModal_content__2fRpl"};